// In Components/ManageClient/ManageClient.js
// (Replace the entire file content with this)

import React, { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import base_url from "../api/bootapi";
import { toast } from "react-toastify";
import NavbarNew from "../Navbar/NavbarNew";
import AdminSidebar from "../Account/MyAccount/AdminSidebar";
import { Backdrop, CircularProgress } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import SwapVert from "@mui/icons-material/SwapVert"; // <--- ADD THIS IMPORT for Admission table headers
import { Col, Row, Container } from "reactstrap";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import "./ManageClient.css";

// --- Re-use components for Applications and Documents ---
// You will need to adapt these components to take clientId as a prop
// and fetch data specific to that client.
import AccountEnquiry from "../Account/AccountEnquiry";
import ApplicationForm from "../Account/ApplicationForm";

const useStyles = makeStyles(() => ({
  backdrop: {
    zIndex: 1000,
    color: "#fff",
  },
}));

const ManageClient = () => {
  const classes = useStyles();
  const { clientId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [clientEmail, setClientEmail] = useState(
    location.state?.clientEmail || localStorage.getItem("manage_client_email")
  );
  const [clientData, setClientData] = useState(null);
  const [backDropOpen, setBackDropOpen] = useState(false);

  const clientdetails = JSON.parse(
    localStorage.getItem("isw_client_details_frontend")
  );

  useEffect(() => {
    if (location.state?.clientEmail) {
      localStorage.setItem("manage_client_email", location.state.clientEmail);
      setClientEmail(location.state.clientEmail);
    }
  }, [location.state]);

  useEffect(() => {
    if (clientEmail) {
      setBackDropOpen(true);
      axios
        .get(`${base_url.api5}/getClientByUsername`, {
          headers: {
            Authorization: `Bearer ${clientdetails?.token}`,
            username: clientEmail,
          },
        })
        .then((res) => {
          setClientData(res.data.data);
          setBackDropOpen(false);
        })
        .catch((err) => {
          console.error("Failed to fetch client data:", err);
          toast.error("Failed to fetch client data.");
          setBackDropOpen(false);
          navigate("/clients_list");
        });
    } else {
      toast.error("Client context lost. Please return to list.");
      navigate("/clients_list");
    }
  }, [clientId, clientEmail, clientdetails?.token, navigate]);

  const handlesidebartab = (val) => {
    navigate("/myaccount");
  };

  const handleBack = () => {
    navigate("/clients_list"); // Navigate back to the client list
  };

  const DetailItem = ({ label, value }) => (
    <li>
      <span className="detail-label">{label}</span>
      <span className={`detail-value ${!value ? "not-set" : ""}`}>
        {value || "-"}
      </span>
    </li>
  );

  const renderProfileDetails = () => {
    if (!clientData || !clientData.clientDetail) {
      return <p>No profile data available.</p>;
    }

    const { clientDetail } = clientData;
    const fullName = `${clientDetail.firstName || ""} ${
      clientDetail.lastName || ""
    }`.trim();
    const initial = fullName ? fullName.charAt(0).toUpperCase() : "N";

    const addressParts = [
      clientDetail.address,
      clientDetail.city,
      clientDetail.state,
      clientDetail.country,
    ];
    const fullAddress = addressParts.filter(Boolean).join(", ");

    return (
      <div className="client-details-card">
        <div className="client-profile-header">
          <div className="client-profile-avatar">{initial}</div>
          <h3 className="client-profile-name">{fullName || "Nigam Dulal"}</h3>
        </div>

        <h5 className="accountbody-title" style={{ fontSize: "1.1rem" }}>
          Personal Details
        </h5>

        <ul className="client-details-list">
          <DetailItem label="Email" value={clientData.email} />
          <DetailItem
            label="Date of Birth"
            value={
              clientDetail.dob
                ? moment(clientDetail.dob).format("DD-MMM-YYYY")
                : null
            }
          />
          <DetailItem label="Contact" value={clientDetail.phone} />
          <DetailItem label="Address" value={fullAddress} />
          <DetailItem label="Postal Code" value={clientDetail.pincode} />
          <DetailItem
            label="Visa Expiry"
            value={
              clientDetail.visaExpiry
                ? moment(clientDetail.visaExpiry).format("DD-MMM-YYYY")
                : null
            }
          />
          <DetailItem label="Visa Type" value={clientDetail.visaType} />
          <DetailItem
            label="Country of Passport"
            value={clientDetail.passport}
          />
          <DetailItem
            label="Passport Number"
            value={clientDetail.passportNumber}
          />
          <DetailItem label="Sub Agent" value={clientData.subAgent} />
          <DetailItem label="Consultant" value={clientData.assigneeName} />
          <DetailItem label="Created By" value={clientData.createdBy} />
          <DetailItem
            label="Created ON"
            value={
              clientData.addedOn
                ? moment(clientData.addedOn).format("DD-MMM-YYYY")
                : null
            }
          />
        </ul>
      </div>
    );
  };

  // --- NEW: Placeholder for the Admission Tab content with table ---
  const renderAdmissionTabContent = () => {
    // This is hardcoded data to match the screenshot for now.
    // You would replace this with actual data fetched from your API for this client.
    const admissionData = [
      {
        sn: 1,
        provider: "Canterbury Institute of Management",
        intake: "Bachelor of Business Hospitality Management",
        status: "COE Received and Updated",
        completedStage: "2025-05-31T18:00:00Z",
        courseStart: "05-Jun-24",
        courseEnd: "04-Jun-28",
      },
      {
        sn: 2,
        provider: "Southern Academy of Higher Education (Head Office)",
        intake: "Bachelor of Business (Hospitality Major)",
        status: "Offer Letter Requested",
        completedStage: "CLOSED",
        courseStart: null,
        courseEnd: null,
      },
      {
        sn: 3,
        provider: "Oban College(Head Office)",
        intake: "Diploma of Civil Construction Design",
        status: "Application Created",
        completedStage: "CLOSED",
        courseStart: null,
        courseEnd: null,
      },
    ];

    return (
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "15px",
            gap: "10px", // Spacing between buttons
          }}
        >
          <button className="btn btn-primary btn-add-workload">Add</button>
          <button className="btn btn-secondary btn-client-list">
            Workload
          </button>
          <button className="btn btn-info btn-client-list">Client List</button>
        </div>

        <table className="admission-table">
          <thead>
            <tr>
              <th>
                <div className="d-flex align-items-center">
                  SN <SwapVert fontSize="small" />
                </div>
              </th>
              <th>
                <div className="d-flex align-items-center">
                  PROVIDER <SwapVert fontSize="small" />
                </div>
              </th>
              <th>
                <div className="d-flex align-items-center">
                  INTAKE <SwapVert fontSize="small" />
                </div>
              </th>
              <th>
                <div className="d-flex align-items-center">
                  STATUS <SwapVert fontSize="small" />
                </div>
              </th>
              <th>
                <div className="d-flex align-items-center">
                  COMPLETED STAGE <SwapVert fontSize="small" />
                </div>
              </th>
              <th>
                <div className="d-flex align-items-center">
                  COURSE START DATE <SwapVert fontSize="small" />
                </div>
              </th>
              <th>
                <div className="d-flex align-items-center">
                  COURSE END DATE <SwapVert fontSize="small" />
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {admissionData.map((item) => (
              <tr key={item.sn}>
                <td>{item.sn}</td>
                <td>{item.provider}</td>
                <td>{item.intake}</td>
                <td>
                  <span
                    className={
                      item.status === "Offer Letter Requested" || item.status === "Application Created"
                        ? "status-closed"
                        : "status-coereceived"
                    }
                  >
                    {item.status}
                  </span>
                </td>
                <td>
                  {item.completedStage === "CLOSED"
                    ? "CLOSED"
                    : moment(item.completedStage).format("YYYY-MM-DD HH:mm:ss")}
                </td>
                <td>{item.courseStart || "-"}</td>
                <td>{item.courseEnd || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="pagination-controls">
          <span>1 to 3 of 3 records</span>
          <button className="btn">&lt;</button>
          <button className="btn active">1</button>
          <button className="btn">&gt;</button>
        </div>
      </div>
    );
  };

  const renderTabs = () => {
    return (
      <div className="client-tabs-container">
        <ul className="nav nav-tabs accountbody_tabnav">
          <li className="nav-item">
            <a className="nav-link active" data-toggle="tab" href="#dashboard">
              Dashboard
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" data-toggle="tab" href="#documents">
              Documents
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" data-toggle="tab" href="#admission">
              Admission
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" data-toggle="tab" href="#migration">
              Migration
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" data-toggle="tab" href="#insurance">
              Insurance
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" data-toggle="tab" href="#skillassessment">
              Skill Assessment
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" data-toggle="tab" href="#accounts">
              Accounts
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" data-toggle="tab" href="#notes">
              Notes
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" data-toggle="tab" href="#eoi">
              EOI
            </a>
          </li>
        </ul>

        <div className="tab-content">
          <div id="dashboard" className="tab-pane active fade show">
            <h3 className="accountbody-title">Client Dashboard</h3>
            <p>This section will show the client's dashboard overview.</p>
            {/* <AccountEnquiry clientId={clientId} /> */}
          </div>

          <div id="documents" className="tab-pane fade">
            <h3 className="accountbody-title">Client Documents</h3>
            <p>This section will show the client's documents.</p>
            {/* <ApplicationForm clientId={clientId} /> */}
          </div>

          <div id="admission" className="tab-pane fade">
            {renderAdmissionTabContent()}
          </div>

          <div id="migration" className="tab-pane fade">
            <h3 className="accountbody-title">Migration</h3>
            <p>Migration details would go here.</p>
          </div>

          <div id="insurance" className="tab-pane fade">
            <h3 className="accountbody-title">Insurance</h3>
            <p>Insurance details would go here.</p>
          </div>

          <div id="skillassessment" className="tab-pane fade">
            <h3 className="accountbody-title">Skill Assessment</h3>
            <p>Skill Assessment details would go here.</p>
          </div>

          <div id="accounts" className="tab-pane fade">
            <h3 className="accountbody-title">Accounts</h3>
            <p>Accounts details would go here.</p>
          </div>

          <div id="notes" className="tab-pane fade">
            <h3 className="accountbody-title">Notes</h3>
            <p>Notes for the client would go here.</p>
          </div>

          <div id="eoi" className="tab-pane fade">
            <h3 className="accountbody-title">EOI</h3>
            <p>Expression of Interest details would go here.</p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <Backdrop className={classes.backdrop} open={backDropOpen}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <NavbarNew />
      <div className="mainaccount">
        <div className="mainaccount_left">
          <AdminSidebar
            sidebartab="clientlist"
            handlesidebartab={handlesidebartab}
          />
        </div>
        <div className="mainaccount_right">
          <div
            style={{
              paddingTop: "30px",
              paddingLeft: "30px",
              paddingRight: "30px",
              paddingBottom: "30px",
            }}
          >
            {clientData ? (
              <Container fluid>
                {/* --- NEW: Page Header Container with white background and BACK button --- */}
                <div className="page-header-container">
                  <div className="page-header-content">
                    <h1 className="page-title">Manage Clients</h1>
                    <p>
                      Client Dashboard{" "}
                      <ChevronRightIcon />{" "}
                      {clientData.clientDetail?.firstName}{" "}
                      {clientData.clientDetail?.lastName}
                    </p>
                  </div>
                  <button className="back-button" onClick={handleBack}>
                    BACK
                  </button>
                </div>

                <Row>
                  <Col md={4} lg={3}>
                    {renderProfileDetails()}
                  </Col>

                  <Col md={8} lg={9}>
                    {renderTabs()}
                  </Col>
                </Row>
              </Container>
            ) : (
              <p>Loading client data...</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageClient;